import React from 'react';
import { UilMobileAndroid, UilTablet, UilDesktop } from '@iconscout/react-unicons';
import { useSelector } from 'react-redux';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { Box, Stack, IconButton } from '@chakra-ui/react';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };

const SelectCanvasResolutionSA = () => {
	const toggleValue = useSelector(selectedToggleValue);

	return (
		<Box ml={5}>
			{/* <Text mt={2} fontFamily={'Inter'} color={'gray.700'} fontWeight='bold' pb={2}>Resolução</Text> */}
			<Stack direction="row">
				<IconButton
					bg={'white'}
					_hover={'none'}
					isActive={toggleValue === 1920}
					_active={y400}
					_focus={'none'}
					variant="outline"
					aria-label="Desktop Layout"
					icon={<UilDesktop size={16} />}
				/>
				<IconButton
					bg={'white'}
					_hover={'none'}
					isActive={toggleValue === 1024}
					_active={y400}
					_focus={'none'}
					variant="outline"
					ml={1}
					aria-label="Tablet Layout"
					icon={<UilTablet size={16} />}
				/>
				<IconButton
					bg={'white'}
					_hover={'none'}
					isActive={toggleValue === 467}
					_active={y400}
					_focus={'none'}
					variant="outline"
					ml={1}
					aria-label="Mobile Layout"
					icon={<UilMobileAndroid size={16} />}
				/>
			</Stack>
		</Box>
	);
};

export default SelectCanvasResolutionSA;
